import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from '../../dashboard/DashboardLayout';
import DataTable from '../../../components/DataTable';
import EditModal from '../../../components/EditModal';
import DynamicForm from '../../../components/dynamicForm';
import DownClickablePopup from '../../../components/DownClickablePopup';
import { advertisementSchema } from '../../../formData/advertisementSchema';
import { showSuccess } from '../../../components/showSuccess';

// sample entries
const initialAds = Array.from({ length: 10 }, (_, i) => ({
    id: String(i + 1),
    mediaUrl: 'https://picsum.photos/seed/1/100/60',
    pageType: 'landscape',
    status: 'Active',
}));

export default function AdvertisementPage() {
    const [ads, setAds] = useState(initialAds);
    const [search, setSearch] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [editAd, setEditAd] = useState(null);

    const filtered = ads.filter(a =>
        a.pageType.toLowerCase().includes(search.toLowerCase()) ||
        a.status.toLowerCase().includes(search.toLowerCase())
    );

    const columns = [
        {
            key: 'media',
            title: 'VIDEO OR IMAGE FILE',
            render: (_, row) => (
                <img src={row.mediaUrl} alt="ad" style={{ height: 40, borderRadius: 4 }} />
            )
        },
        { key: 'pageType', title: 'PAGE TYPE' },
        {
            key: 'status',
            title: 'STATUS',
            render: (_, row) => (
                <span
                    style={{
                        padding: '4px 8px',
                        borderRadius: 12,
                        background: row.status === 'Active' ? '#d1fae5' : '#fee2e2',
                        color: row.status === 'Active' ? '#065f46' : '#991b1b',
                        fontSize: 12,
                    }}
                >
                    {row.status}
                </span>
            )
        },
        {
            key: 'actions',
            title: 'ACTION',
            render: (_, row) => (
                <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={() => openEdit(row)} title="Edit" style={styles.actionBtn}>
                        <span className="material-icons">edit</span>
                    </button>
                    <button title="View" style={styles.actionBtn}>
                        <span className="material-icons">visibility</span>
                    </button>
                    <button onClick={() => copyLink(row)} title="Copy Link" style={styles.actionBtn}>
                        <span className="material-icons">content_copy</span>
                    </button>
                    <button onClick={() => deleteAd(row.id)} title="Delete" style={styles.actionBtn}>
                        <span className="material-icons" style={{ color: '#e53e3e' }}>delete</span>
                    </button>
                </div>
            )
        }
    ];

    function openEdit(ad) {
        setEditAd(ad || { mediaUrl: '', pageType: 'landscape', status: 'Active' });
        setModalOpen(true);
    }

    async function onSave(action, data) {
        if (action === 'cancel') {
            setModalOpen(false);
            return;
        }
        if (action === 'save') {
            setAds(list => {
                if (editAd && editAd.id) {
                    return list.map(a => a.id === editAd.id ? { ...a, ...data } : a);
                } else {
                    const id = String(list.length + 1);
                    return [...list, { id, ...data }];
                }
            });
            setModalOpen(false);
            await showSuccess('Advertisement saved!');
        }
    }

    function deleteAd(id) {
        if (window.confirm('Delete this advertisement?')) {
            setAds(list => list.filter(a => a.id !== id));
        }
    }

    function copyLink(row) {
        const url = `${window.location.origin}/ad/${row.id}`;
        navigator.clipboard.writeText(url);
        showSuccess('Link copied to clipboard!');
    }

    return (
        <>
            <div style={styles.container}>
                <div style={styles.toolbar}>
                    <h1 style={styles.title}>Advertisement</h1>
                    <div style={styles.rightSideFilter}>
                        <button style={styles.addBtn} onClick={() => openEdit(null)}>+ Add Advertisement</button>
                        <input
                            type="text"
                            placeholder="Search..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            style={styles.searchInput}
                        />
                        <DownClickablePopup popUpTitle="Filter" filters={<></>}>
                            <button style={styles.iconBtn}><span className="material-icons">filter_list</span></button>
                        </DownClickablePopup>
                        <button style={styles.iconBtn}><span className="material-icons">file_download</span></button>
                        <button style={styles.iconBtn}><span className="material-icons">print</span></button>
                    </div>
                </div>

                <DataTable data={filtered} columns={columns} rowKey="id" />

                <EditModal
                    visible={modalOpen}
                    schema={advertisementSchema}
                    initialData={editAd}
                    onClose={() => setModalOpen(false)}
                    onSubmit={onSave}
                />
            </div>
        </>
    );
}

const styles = {
    container: {
        margin: '0 auto',
        color: '#333'
    },
    toolbar: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, justifyContent: 'space-between', },
    title: {
        fontSize: 24,
        marginTop: 0,
        color: '#4a5568',
    },
    addBtn: { background: '#7c4dff', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: 4, cursor: 'pointer' },
    searchInput: { padding: '8px 12px', borderRadius: 4, border: '1px solid #ccc', flex: '0 0 200px' },
    iconBtn: { background: 'none', border: 'none', cursor: 'pointer', fontSize: 20 },
    actionBtn: { background: 'none', border: 'none', cursor: 'pointer', fontSize: 18 },
    rightSideFilter: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
};
